import type { TabConfig } from '../hooks/useTabsState';
import { PATIENT_TAB_IDS } from '../Patient.constants';

type PatientTabId = (typeof PATIENT_TAB_IDS)[keyof typeof PATIENT_TAB_IDS];

interface BuildPatientTabConfigParams {
  isGDCEnabled: boolean;
  scheduledConsultActive: boolean;
}

const buildPatientTabConfig = ({
  isGDCEnabled,
  scheduledConsultActive,
}: BuildPatientTabConfigParams): TabConfig<PatientTabId>[] => {
  return [
    {
      id: PATIENT_TAB_IDS.SCHEDULED_CONSULT,
      label: 'Scheduled Consult',
      visible: isGDCEnabled && scheduledConsultActive,
    },
    {
      id: PATIENT_TAB_IDS.DETAILS,
      label: 'Patient Details',
      visible: true,
    },
    {
      id: PATIENT_TAB_IDS.CONSULTATIONS,
      label: isGDCEnabled && scheduledConsultActive ? 'Consult History' : 'Consultations',
      visible: true,
    },
    {
      id: PATIENT_TAB_IDS.PRESCRIPTIONS,
      label: 'Prescriptions',
      visible: true,
    },
    {
      id: PATIENT_TAB_IDS.DOCUMENTATION,
      label: 'Documentation',
      visible: true,
    },
  ];
};

export { buildPatientTabConfig };
export type { PatientTabId };
